<mat-card style="margin-top:20px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <mat-card-content>

        @if (isProcessing) {
            <div class="d-flex justify-content-center" style="margin-top:20px;margin-bottom:20px;">
                <span style="font-size:24px;font-weight:bold">Please stand by while we update the Flash Pools...</span>
            </div>
        }
        @else {
            <span style="margin-left:0px;margin-top:20px;" class="lanai-page-title">Add Flash Pool</span>

            <!-- Pools are add/delete only - Flash resolves pools by NAME on the account, so renaming
                 one here would orphan every account already pointing at the old name. -->
            <form (ngSubmit)="onSubmitAddPool()" novalidate [formGroup]="poolForm" style="margin-top:20px;">
                <div class="row">
                    <div class="col-4">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Pool Name</mat-label>
                            <input matInput placeholder="Pool Name" maxlength="255" formControlName="poolName" autocomplete="chrome-off" />
                            <mat-error>The pool name is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" [disabled]="!poolForm.valid">Submit</button>
                <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="onResetPoolForm()">Clear</button>
            </form>

            <div style="margin-top:20px;"></div>

            @if (pools.length > 0) {
                <span style="margin-left:0px;" class="lanai-page-title">Pool Display Order</span>
                <p class="gray-text" style="margin-left:0px;margin-top:5px;font-size:13px;">
                    Drag a pool to change the order it appears in the Pool dropdowns.
                </p>

                <div cdkDropList (cdkDropListDropped)="onPoolDropped($event)" class="pool-drop-list">
                    @for (pool of pools; track pool.poolId) {
                        <div cdkDrag class="pool-drop-row">
                            <mat-icon cdkDragHandle class="pool-drag-handle" matTooltip="Drag to reorder">drag_indicator</mat-icon>
                            <span class="pool-drop-name">{{ pool.poolName }}</span>
                            <button mat-icon-button aria-label="Delete Pool" (click)="onDeletePool(pool.poolId)" matTooltip="Delete Pool">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    }
                </div>
            }
            @else {
                <p class="gray-text" style="margin-left:20px;">No Flash Pools have been added for this Lot.</p>
            }
        }

    </mat-card-content>
</mat-card>
